module.exports = __webpack_public_path__ + "static/media/acerta-vial.a5456e78.svg";